<template>
  <div style="position: relative">
    <div class="row">
      <!-- <amf-datepicker v-model.lazy="internalStartDate" :label="startLabel" :max="maxDate" :openDate="startOpenDate" :validator="$v.internalStartDate"></amf-datepicker>
      <amf-datepicker v-model.lazy="internalEndDate" :label="endLabel" :min="minDate" :openDate="endOpenDate"></amf-datepicker>-->
      <amf-format-input
        :label="startLabel"
        v-model.lazy="internalStartDate"
        format="__/__/____"
        placehold="mm/dd/yyyy"
        :validator="$v.internalStartDate"
        :valueWithFormat="true"
      ></amf-format-input>
      <amf-format-input
        :label="endLabel"
        v-model.lazy="internalEndDate"
        format="__/__/____"
        placehold="mm/dd/yyyy"
        :validator="$v.internalEndDate"
        :valueWithFormat="true"
      ></amf-format-input>
    </div>
  </div>
</template>

<script>
import { v } from "framework";

export default {
  props: {
    label: {
      type: String,
      default: null,
      required: false
    },
    startDate: {
      type: [Date, String],
      default: null
    },
    endDate: {
      type: [Date, String],
      default: null
    },
    hideCalendar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalStartDate: this.startDate,
      internalEndDate: this.endDate,
      startUpdating: false,
      endUpdating: false,
      amfOptions: { layout: "two-column", noTracking: true }
    };
  },
  created() {
    this.setDates();
  },
  computed: {
    maxDate() {
      return this.internalEndDate || new Date(2099, 11, 31);
    },
    minDate() {
      return this.internalStartDate || new Date(1900, 0, 1);
    },
    startLabel() {
      let startLabel = "Start Date";
      if (this.label) startLabel = `${this.label} ${startLabel}`;
      return startLabel;
    },
    endLabel() {
      let endLabel = "End Date";
      if (this.label) endLabel = `${this.label} ${endLabel}`;
      return endLabel;
    },
    startOpenDate() {
      return this.internalStartDate
        ? this.internalStartDate
        : this.internalEndDate;
    },
    endOpenDate() {
      return this.internalEndDate
        ? this.internalEndDate
        : this.internalStartDate;
    }
  },
  methods: {
    async load() {
      this.setDates();
    },
    setDates() {
      this.internalStartDate = this.startDate;
      this.internalEndDate = this.endDate;

      if (this.startDate && !_.isDate(this.startDate)) {
        this.internalStartDate = moment(this.startDate, [
          "MM/DD/YYYY",
          "YYYY-MM-DD",
          "MM-DDs-YYTHH-mm-ss"
        ]).toDate();
      }

      if (this.endDate && !_.isDate(this.endDate)) {
        this.internalEndDate = moment(this.endDate, [
          "MM/DD/YYYY",
          "YYYY-MM-DD",
          "MM-DD-YYTHH-mm-ss"
        ]).toDate();
      }
    },
    clear() {
      this.internalStartDate = null;
      this.internalEndDate = null;
    },
    isInGoodFormat(v) {
      if (v) {
        if (v instanceof Date) return true;
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;
        const matches = regex.exec(v);

        if (!matches) return false;
        if (matches.length <= 0) return false;

        return utils.isValidDate(v);
      }
      return true;
    }
  },
  watch: {
    internalStartDate(newValue) {
      if (this.startUpdating) return;
      if (newValue && newValue.length < 8) return;
      let date = newValue
        ? moment(newValue)
            .startOf("day")
            .toDate()
        : null;
      this.$emit("update:startDate", date);
    },
    internalEndDate(newValue) {
      if (this.endUpdating) return;
      if (newValue && newValue.length < 8) return;
      let date = newValue
        ? moment(newValue)
            .add(1, "days")
            .startOf("day")
            .subtract(1, "seconds")
            .toDate()
        : null;
      this.$emit("update:endDate", date);
    },
    startDate(newValue) {
      if (newValue) return;
      this.startUpdating = true;
      this.internalStartDate = null;
      setTimeout(x => (this.startUpdating = false), 0);
    },
    endDate(newValue) {
      if (newValue) return;
      this.endUpdating = true;
      this.internalEndDate = null;
      setTimeout(x => (this.endUpdating = false), 0);
    }
  },
  validations() {
    return {
      internalStartDate: v.build(
        v.custom(value => {
          if (!this.internalStartDate || !this.internalEndDate) return true;
          return moment(this.internalStartDate).toDate() <= moment(this.internalEndDate).toDate();
        }, "Start Date must be greater than End Date"),
        v.custom(
          x => {
            return this.isInGoodFormat(x);
          },
         `Invalid date format, please try again`)
      ),
      internalEndDate: v.build(
        v.custom(
          x => this.isInGoodFormat(x),
          `Invalid date format, please try again`
        )
      )
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/framework/primitives/AmfDateRange.vue